"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODAL_DIMENSIONS = exports.BG_COLOR = exports.APPEARANCE_MODES = exports.MODAL_EVENTS = void 0;
exports.MODAL_EVENTS = {
    MODAL_CLOSE: 'MODAL_CLOSE',
    MODAL_CLOSE_SUCCESS: 'MODAL_CLOSE_SUCCESS',
    MODAL_CLOSE_FAILURE: 'MODAL_CLOSE_FAILURE',
    SET_MODAL_STYLE: 'SET_MODAL_STYLE',
    MODAL_UPDATE_URL_PARAMS: 'MODAL_UPDATE_URL_PARAMS'
};
exports.APPEARANCE_MODES = {
    DARK: 'DARK',
    LIGHT: 'LIGHT'
};
exports.BG_COLOR = {
    DARK: "#121212",
    LIGHT: "white"
};
// In pixels
exports.MODAL_DIMENSIONS = {
    MODAL_HEIGHT: '650',
    MODAL_WIDTH: '750',
    MODAL_OFFSET: '20'
};
